module.exports = __webpack_public_path__ + "img/iconJiaYouBaoBiao.ad59eddb.svg";